// extracted by mini-css-extract-plugin
export var caption = "figure-module--caption--8663d typography-module--small--2877f";
export var root = "figure-module--root--542da";